"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entry = exports.useEntryStyle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const Databox_1 = require("./Databox");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Badge_1 = require("../Badge");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const useEntryStyle = (status, isFirst) => {
    const t = (0, translate_1.useTranslations)();
    switch (status) {
        case enums_1.TimeReportStatus.REPORTED:
            return {
                backgroundColor: constants_1.Color.LIGHTEST_BLUE,
                color: constants_1.Color.BLUE,
                badge: 'blue',
                icon: 'PencilAltIcon',
                label: isFirst ? t.timesheets.reported() : t.timesheets.updated(),
            };
        case enums_1.TimeReportStatus.RETURNED:
            return {
                backgroundColor: constants_1.Color.LIGHTER_RED,
                color: constants_1.Color.MEDIUM_DARK_RED,
                badge: 'red',
                icon: 'ReplyIcon',
                label: t.timesheets.returned(),
            };
        case enums_1.TimeReportStatus.ATTESTED:
            return {
                backgroundColor: constants_1.Color.DARK_GREEN,
                color: constants_1.Color.WHITE,
                badge: 'dark-green',
                icon: 'CheckCircleIcon',
                label: t.timesheets.attested(),
            };
        default:
            return null;
    }
};
exports.useEntryStyle = useEntryStyle;
const IconWrapper = (0, styled_1.default)(Flex_1.Flex)(({ background }) => ({
    border: `5px solid ${constants_1.Color.WHITE}`,
    background,
    borderRadius: '50%',
    height: constants_1.theme.spacing['4'],
    width: constants_1.theme.spacing['4'],
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
}));
const Entry = (props) => {
    const t = (0, translate_1.useTranslations)();
    const styles = (0, exports.useEntryStyle)(props.report.status, !props.previousReport);
    if (!styles)
        return null;
    const SOURCE = {
        [enums_1.TimeReportSource.CANDIDATE]: t.timesheets.resource(),
        [enums_1.TimeReportSource.ORDERER]: t.timesheets.unit_manager(),
        [enums_1.TimeReportSource.SUPPLIER]: t.timesheets.consultant_manager(),
    };
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 1, children: [(0, jsx_runtime_1.jsx)(Flex_1.Flex, { styles: {
                    alignItems: 'center',
                    pl: 4.5,
                    fontSize: constants_1.theme.font.size['6'],
                }, children: (0, jsx_runtime_1.jsxs)(Text_1.Text, { color: constants_1.Color.CHARCOAL, children: [props.report.reporter?.fullName, ' ', (0, jsx_runtime_1.jsxs)("i", { children: ["(", SOURCE[props.report.source], ")"] })] }) }), (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { items: "center", children: [(0, jsx_runtime_1.jsx)(IconWrapper, { background: styles.backgroundColor, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: styles.icon, size: "sm", color: styles.color }) }), (0, jsx_runtime_1.jsx)(Badge_1.Badge, { color: styles.badge, styles: { ml: 2 }, size: "sm", children: styles.label }), (0, jsx_runtime_1.jsx)(Text_1.Text, { textAlign: "end", ml: "auto", color: constants_1.Color.DARK_GREY, fontSize: constants_1.theme.font.size[6.5], children: t.$date
                            .unix(props.report.createdAt)
                            .formatSignificant({ showTime: true }) })] }), (0, jsx_runtime_1.jsx)(Databox_1.DataBox, { ...props, ml: constants_1.theme.spacing[4] })] }));
};
exports.Entry = Entry;
